<template>
    <div class="index-container">
        <div class="course-content">
            <div class="select-wrapper">
                <div class="select-box">
                    <div class="select-name">课程分类</div>
                    <div class="select-left">
                        <el-cascader v-model="courseClassValue" style="width: 420px" size="medium" :props="keyObj"
                                     :options="courseClass" ref="specObj" clearable placeholder="选择课程分类"
                                     @change="changeCourseClass"></el-cascader>
                    </div>
                </div>
                <div class="select-btn">
                    <i class="el-icon-plus"></i>
                    <span @click="createCourseBtn">创建课程</span>
                </div>
            </div>
            <!--课程列表-->
            <el-table :data="courseTableData" height="1%" size="medium"
                      :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#F6F6F6', height:'60px'}"
                      class="customTable" :cell-style="{fontSize: '16px',color: '#333', height:'100px'}">
                <el-table-column label="封面" width="210" align="left">
                    <template slot-scope="scope">
                        <div class="img-box">
                            <img class="cover-img" :src="scope.row.cover" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="课程名称" width="300">
                    <template slot-scope="scope">
                        <span class="text-overflow-2" :title="scope.row.name">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程简介">
                    <template slot-scope="scope">
                        <span class="text-overflow-2"
                              :title="scope.row.intro">{{ scope.row.intro }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" width="200" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.admin_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link :underline="false" type="success" @click="editCourse(scope.row, scope.$index)">编辑
                            </el-link>
                            <el-link :underline="false" type="danger"
                                     @click="deleteRow(scope.$index, courseTableData, scope.row)">删除
                            </el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination class="pages-center" :total="totalPages" @current-change="handleCurrentChange">
            </pagination>
            <!--编辑课程弹窗-->
            <el-dialog :title="editCourseTitle" :visible.sync="editStatus" :close-on-click-modal="false" top="2vh"
                       class="upload-resources-dialog create-course-dialog">
                <!--                <dialog-edit-course :data.sync="data" :types="courseTypeList" :id="courseId" v-if="editStatus"></dialog-edit-course>-->
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import pagination from 'components/pagination.vue';
    import {cateCates, courseList, courseDel} from '@/utils/apis'

    export default {
        name: "CourseManage",
        components: {
            pagination
        },
        data() {
            return {
                //课程分类数据
                courseClassValue: [],
                courseClass: [],
                keyObj: {
                    label: 'name',
                    value: 'id'
                },
                //课程类型数据
                courseTypeList: [],
                //选择课程类型标识
                typeCurrent: 0,
                //课程列表数据
                courseTableData: [],
                //分页字段
                page: 1,
                currentPage: 1,
                totalPages: 0,
                editStatus: false,
                data: null,
                editCourseTitle: '',
                courseId: 0,
                courseClassId: '',
            }
        },
        created() {
            this.getSpecializedList();
            this.getCourses();
        },
        methods: {
            //课程分类
            getSpecializedList() {
                let params = {
                    type: '1'
                }
                cateCates(params).then((res) => {
                    if (res.code == 200) {
                        for (let i in res.data) {
                            this.courseClass.push(res.data[i])
                        }
                    }
                })
            },
            getCourseClassData(data) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].children.length === 0) {
                        delete data[i].children;
                    } else {
                        this.getCourseClassData(data[i].children)
                    }
                }
                return data;
            },
            createCourseBtn() {
                this.$router.push('/course/create')
            },
            changeCourseClass() {
                this.courseClassId = this.courseClassValue[this.courseClassValue.length - 1];
                this.getCourses();
            },
            getCourses() {
                let params = {
                    page: this.page,
                    paging: 1,
                    pageSize: 10,
                }
                if (this.courseClassId !== '') {
                    params.classify_id = this.courseClassId
                }
                courseList(params).then((res) => {
                    if (res.code == 200) {
                        this.courseTableData = res.data.data
                        this.totalPages = res.data.total
                    }
                }).catch((err) => {
                    console.error(err)
                })
            },
            //编辑课程
            editCourse(row, index) {
                this.$router.push({
                    path: '/course/create',
                    query: {
                        id: row.id
                    }
                })
            },
            //删除课程
            deleteRow(index, rows, row) {
                this.$confirm(`是否删除该课程，删除将无法恢复`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: "green-message-box",
                    type: 'warning'
                }).then(() => {
                    let param = {
                        id: row.id
                    }
                    courseDel(param).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            this.getCourses()
                        }
                    }).catch((err) => {
                        console.error(err)
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            //翻页
            handleCurrentChange(val) {
                this.page = val;
                this.getCourses();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .index-container {
        height: 100%;
    }

    .course-content {
        padding: 0 20px 20px;
        height: calc(100% - 40px);
        display: flex;
        flex-direction: column;

        ::v-deep .el-table--border td:first-child .cell {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 178px;
            height: 100px;
            margin: 0 auto;
            padding: 0;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        ::v-deep .el-table__header .has-gutter tr th:first-child {
            padding-left: 20px;
        }
    }

    .select-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .select-box {
            display: flex;
            align-items: center;

            .select-name {
                color: #333333;
                font-weight: 400;
            }

            .select-left {
                margin-left: 12px;

                ::v-deep .el-input__inner{
                    height: 40px;
                }
            }
        }

        .select-btn {
            width: 94px;
            height: 40px;
            background: #F23B2F;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            cursor: pointer;

            i {
                font-size: 14px;
            }

            span {
                margin-left: 5px;
                line-height: 90px;
            }
        }
    }

    .type-wrapper {
        margin-top: 10px;
        display: flex;

        .type-name {
            width: 100px;
            margin-top: 10px;
            line-height: 30px;
            color: #000;
        }

        .type-list {
            .type-item {
                display: inline-block;
                padding: 4px 10px;
                -webkit-border-radius: 2px;
                -moz-border-radius: 2px;
                border-radius: 4px;
                margin: 10px 10px 0 0;
                font-size: 14px;
                border: 1px solid transparent;
                cursor: pointer;
                color: #666;
                transition: all .3s ease-in;

                &.current {
                    color: #409eff;
                    background: #ecf5ff;
                    border: 1px solid #d9ecff;
                }

                &:hover {
                    color: #409eff;
                }
            }
        }
    }

    .customTable {
        width: 100%;
        flex: 1;
        margin: 16px 0 0;

        .link-box {
            height: 16px;
            display: flex;
            justify-content: center;
        }

        .img-box {
            width: 120px;
            height: 68px;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

    .pages-center {
        margin-bottom: 0;
    }

    .video-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 9;

        .close-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 30px;
            width: 30px;
            height: 30px;
            line-height: 1;
            background: rgba(0, 0, 0, .7);
            color: #fff;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                color: #409EFF;
            }
        }

        .video-content {
            width: 50%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: 3px solid #111;

            video {
                outline: none;
                display: block;
            }
        }
    }

    .upload-btn {
        position: relative;

        input {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            opacity: 0;
            cursor: pointer;
        }
    }
</style>